// FILE: src/components/admin/StaffRolePicker.jsx
// Choose a staff member's role (RBAC): a labelled select of the roles from
// GET /api/admin/roles, with what the chosen role is for underneath.
// Loading and failure are said in words; the select never shows a raw id.
import React from "react";
import { Alert, Button, MenuItem, Stack, TextField } from "@mui/material";
import { errorMessage } from "../../i18n/errors";

export default function StaffRolePicker({ id = "staffRoleId", value, onChange, roles, loading, error, onRetry, fieldError, inputRef, required = true, helper }) {
  if (error) {
    return (
      <Alert
        severity="error"
        role="alert"
        action={
          onRetry ? (
            <Button color="inherit" onClick={onRetry}>
              Try again
            </Button>
          ) : null
        }
      >
        We couldn't load the roles. {errorMessage(error)}
      </Alert>
    );
  }
  const list = Array.isArray(roles) ? roles : [];
  const chosen = list.find((r) => r.id === value);
  return (
    <Stack spacing={1}>
      <TextField
        select
        id={id}
        name="staffRoleId"
        label="Role"
        value={list.some((r) => r.id === value) ? value : ""}
        onChange={(e) => onChange(e.target.value)}
        inputRef={inputRef}
        error={!!fieldError}
        helperText={fieldError || helper || (loading ? "Loading the roles…" : chosen ? chosen.description || `${chosen.permissions.length} permissions` : "What this person may do in the admin area.")}
        disabled={loading && !list.length}
        required={required}
        fullWidth
      >
        {list.map((r) => (
          <MenuItem key={r.id} value={r.id}>
            {r.name}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
